import { useState, useEffect, useCallback } from 'react'
import { doRequestFile, doRequestPost } from '../../api';
import { defaultToast, doToast } from '../../utils';
import { toast } from 'react-toastify'

export const useSaveUpdate = ({ data, url, hasFile, setReload, setError = _ => { }, showNotification = true }) => {
  const [doSubmit, setDoSubmit] = useState(false);
  const [response, setResponse] = useState(null);

  useEffect(() => {
    if (response !== null) {
      setResponse(null);
      if (showNotification) {
        doToast({
          ...response,
          toast
        })
      }
      setDoSubmit(false);

      if (response.response === 'success') {
        setReload(response.data);
      } else {
        setError(response)
      }
    }
  }, [response, setDoSubmit, setReload, setResponse, setError, showNotification])

  const fetchData = useCallback(async () => {
    if (doSubmit) {
      try {
        if (hasFile) {
          const saveCustomers = await doRequestFile({
            url,
            data
          })
          setResponse(saveCustomers)
        } else {
          const saveCustomers = await doRequestPost({
            url,
            data
          })
          setResponse(saveCustomers)
        }
      } catch (error) {
        setResponse(defaultToast())
      }
    }
  }, [doSubmit, data, url, hasFile])

  useEffect(() => {
    fetchData()
  }, [fetchData])

  return {
    doSubmit,
    setDoSubmit
  }
}